import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Alert } from 'antd'

import Box from '~/core/Box'
import Text from '~/core/Text'
import {
    ThreadsTabType,
    ThreadsPropsType,
} from '~/apps/consumer/components/PartViewerModal/types'
import { hoverHole, hoverHoleGroup } from '~/redux-modules/qmr-viewer/actions'
import {
    getHoveredHole,
    getSelectedHole,
} from '~/redux-modules/qmr-viewer/selectors'
import { ViewerStateType } from '~/redux-modules/qmr-viewer/types'

import TapsSidebar from './components/TapsSidebar'

class TapsSidebarWrapper extends PureComponent<ThreadsTabType, {}> {
    onHoverHole = (holeId: string) => {
        const { dispatch } = this.props

        if (dispatch) {
            dispatch(hoverHole({ holeId }))
        }
        return null
    }

    onHoverHoleGroup = (holeGroupId: string) => {
        const { dispatch } = this.props

        if (dispatch) {
            dispatch(hoverHoleGroup({ holeGroupId }))
        }
        return null
    }

    render() {
        const { holes, hoveredFeatureId, clickedFeatureId, placement } =
            this.props

        return (
            <>
                <Alert
                    message={
                        <Box direction="row">
                            <Text
                                fontSize="14px"
                                fontWeight={300}
                                color="blackAlpha65"
                            >
                                The following threads have been configured
                            </Text>
                        </Box>
                    }
                    type="info"
                    showIcon
                />
                <Box direction="col" paddingTop="20px" height="100%">
                    <TapsSidebar
                        holes={holes}
                        onHoverHole={this.onHoverHole}
                        onHoverHoleGroup={this.onHoverHoleGroup}
                        hoveredFeatureId={hoveredFeatureId}
                        clickedFeatureId={clickedFeatureId}
                        placement={placement}
                    />
                </Box>
            </>
        )
    }
}

function mapStateToProps(
    state: Record<string, ViewerStateType>,
    ownProps: ThreadsPropsType,
) {
    const hoveredHole = getHoveredHole(state, {
        holes: ownProps?.holes || [],
    })
    const selectedHole = getSelectedHole(state, {
        holes: ownProps?.holes || [],
    })

    return {
        hoveredFeatureId: hoveredHole?.id || null,
        clickedFeatureId: selectedHole?.id || null,
    }
}

export default connect(mapStateToProps)(TapsSidebarWrapper)
